import { Enums } from '../../../models/common/enums'
import { IUserSession } from '../../../helpers/user-session'

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { SimcardDetailsDirectiveController } from './simcards-details.directive.controller'

//#region Asset Imports

import * as TEMPLATE from './simcards-details.tpl.html'

//#endregion

export class SimcardDetailsDirective implements ng.IDirective {
    restrict = 'E'
    scope = {
        id: '=' //Wymagane do wszystkich okienek details, które mogą być wywołane wielokrotnie w sposób zagnieżdżony
    }

    controller = ['$scope', '$q', '$timeout', 'api', 'logger', 'localDictionary', 'userSession',
        ($scope, $q: ng.IQService, $timeout: ng.ITimeoutService, api: Api, logger: LoggerService, localDictionary: LocalDictionaryFactory, userSession: IUserSession) => {
            return new SimcardDetailsDirectiveController($scope, $q, $timeout, api, logger, localDictionary, userSession, Enums.ReferenceType.IdSimCard)
        }]
    template = TEMPLATE
}